<template>
    <a
        v-if="value"
        target="_blank"
        title="Attachment"
        :href="value"
    >
        <font-awesome-icon
            :icon="['fas', 'paperclip']"
            class="text-secondary"
            size="lg"
        ></font-awesome-icon>
    </a>
</template>

<script>
    export default {
        data() {
            return {
                value: null,
            }
        },
        created() {
            this.value = this.params.value;
        }
    }
</script>
